import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BoundariesActions from "../../../store/actions/Boundaries";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import * as CityActions from "../../../store/actions/City";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import ToggleSwitch from "../../Common/ToggleSwitch";
import variables from "../../../constants/assets/variables";
import { setStatus } from "../../../store/actions/User";

const CitiesFilterModal = ({
  modalState,
  handleClose,
  activeFilters,
  setBoundaryLists,
  resetStore,
  getCityList,
  nextPageCity,
  getCity,
  setStatus,
}) => {
  const [boundariesFilter, setBoundariesFilter] = useState({
    cityIds: [],
    isLocalitySupported: true,
    isTest: false,
    zone_supported: false,
    zone_unsupported: false,
    show_type: "",
  });
  const [entities, setEntities] = useState({
    showLocalities: false,
    showZones: false,
  });

  const [priorityFlag, setPriorityFlag] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (boundariesFilter.cityIds.length === 0) {
      setStatus({
        type: "error",
        message: "Please select atleast one city",
      });
      return;
    }
    if (!entities.showLocalities && !entities.showZones) {
      setStatus({
        type: "error",
        message: "Please select atleast one of Zone or locality",
      });
      return;
    }
    const updatedFilters = { ...boundariesFilter };
    if (entities.showZones && entities.showLocalities) {
      updatedFilters.show_type = "both";
    } else if (entities.showZones) {
      updatedFilters.show_type = "zone";
    } else {
      updatedFilters.show_type = "locality";
    }
    setBoundaryLists(updatedFilters).then((_) => {
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetStore();
    handleClose();
  };

  const handleEntityChange = (type, val) => {
    let oldVal = { ...entities };
    oldVal[type] = val;
    setEntities(oldVal);
  };

  const handleChange = (type, val) => {
    if (type === "cityIds") {
      let newValue = { ...boundariesFilter, cityIds: val };
      setBoundariesFilter(newValue);
    } else {
      let oldValue = boundariesFilter[type];
      let newValue = { ...boundariesFilter };
      newValue[type] = !oldValue;
      setBoundariesFilter(newValue);
    }
  };

  useEffect(() => {
    setPriorityFlag(true);
    setEntities({
      showLocalities:
        activeFilters.show_type === "both" ||
        activeFilters.show_type === "locality",
      showZones:
        activeFilters.show_type === "both" ||
        activeFilters.show_type === "zone",
    });
    setBoundariesFilter({
      cityIds: activeFilters.cityIds,
      isTest: activeFilters.isTest,
      isLocalitySupported: activeFilters.isLocalitySupported,
      zone_supported: activeFilters.zone_supported,
      zone_unsupported: activeFilters.zone_unsupported,
      show_type: activeFilters.show_type,
    });
  }, [activeFilters]);

  return (
    <NoFooterModal
      header={true}
      heading="Cities Selection"
      handleClose={handleClose}
      id="citiesFilterFilterModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <div>
        <InfiniteScrollDropdown
          multiple={true}
          id="cityFilterDropdown"
          className="sushi-dropdown"
          priorityFlag={priorityFlag}
          appliedFilters={{}}
          activeFilters={{ city_id: boundariesFilter.cityIds }}
          getActiveList={getCityList}
          nextPage={nextPageCity}
          resKey="cities"
          modalState={"Filter"}
          keyName="city_id"
          labelKey="city_name"
          getDataLabelKey="city.city_name"
          keyTypeToSet="id"
          label="City"
          handleChange={(_key, val) => handleChange("cityIds", val)}
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
          getActiveItemById={getCity}
        />
        <div className="flex items-center flex-start">
          <ToggleSwitch
            className="semibold mr-10"
            label="Show Localities"
            id="sushi-switch"
            size={10}
            spacing={4}
            isActive={entities.showLocalities}
            handleChange={handleEntityChange}
            keyName={`showLocalities`}
          />
          <ToggleSwitch
            className="semibold"
            label="Show Zones"
            id="sushi-switch"
            size={10}
            spacing={4}
            isActive={entities.showZones}
            handleChange={handleEntityChange}
            keyName={`showZones`}
          />
        </div>
        {entities.showLocalities && (
          <EntityContainer className="p-20">
            <ToggleSwitch
              className="semibold"
              label="Show only supported localities"
              id="sushi-switch"
              size={10}
              spacing={4}
              isActive={boundariesFilter.isLocalitySupported}
              handleChange={() => handleChange("isLocalitySupported")}
              keyName={`isLocalitySupported`}
              changeOnState={true}
            />
            <ToggleSwitch
              className="semibold"
              label="Show only test localities"
              id="sushi-switch"
              size={10}
              spacing={4}
              isActive={boundariesFilter.isTest}
              handleChange={() => handleChange("isTest")}
              keyName={`isTest`}
              changeOnState={true}
            />
          </EntityContainer>
        )}
        {entities.showZones && (
          <EntityContainer className="p-20">
            <ToggleSwitch
              className="semibold"
              label="Show supported zones"
              id="sushi-switch"
              size={10}
              spacing={4}
              isActive={boundariesFilter.zone_supported}
              handleChange={() => handleChange("zone_supported")}
              keyName={`zone_supported`}
              changeOnState={true}
            />
            <ToggleSwitch
              className="semibold"
              label="Show unsupported zones"
              id="sushi-switch"
              size={10}
              spacing={4}
              isActive={boundariesFilter.zone_unsupported}
              handleChange={() => handleChange("zone_unsupported")}
              keyName={`zone_unsupported`}
              changeOnState={true}
            />
          </EntityContainer>
        )}
      </div>
    </NoFooterModal>
  );
};

const EntityContainer = styled.div`
  border: 1px solid ${variables.grey300};
  border-radius: 8px;
  background: ${variables.grey100};
  margin-bottom: 10px;
  margin-right: 10px;
`;

function mapStateToProps(state) {
  const { Boundaries, City } = state;
  return {
    activeFilters: Boundaries.activeFilters,
    cityList: City.cityList,
    nextPageCity: City.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getCity: bindActionCreators(CityActions.getBulkCities, dispatch),
    resetStore: () => dispatch(BoundariesActions.resetState({})),
    setBoundaryLists: bindActionCreators(
      BoundariesActions.loadBoundaryLists,
      dispatch
    ),
    setStatus: bindActionCreators(setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CitiesFilterModal);
